export default "__VITE_ASSET__3d93826c__"